export default import.meta.ROLLUP_FILE_URL_qJ3179NUSnuVORySbTDnXg